// var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

// js/helper/currency.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.theme.settings.moneyWithCurrencyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
let currencyFormat = window.themeVariables.settings.moneyWithCurrencyFormat;
let currencyFormatWithoutCode = currencyFormat.match(/\{\{\s*\w+\s*\}\}/)?.[0] || "{{ amount }}";

$('document').ready(function () {

  $('.get-relief_wrapper').slick({
      slidesToShow: 3,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            arrows: false,
            slidesToShow: 1
          }
        }
      ]
  });

  $('.pdp-benefits_wrapper').slick({
      slidesToShow: 3,
      arrows: true,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 699,
          settings: {
            arrows: false,
            slidesToShow: 1
          }
        }
      ]
  });

    $('.consistent-result_wrapper').slick({
      slidesToShow: 2,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 699,
          settings: {
            arrows: false,
            slidesToShow: 1
          }
        }
      ]
  });


  $('body').on('click','.pdp-specification_block-title', function() {
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdown = activeTitle.next(".pdp-specification_block-content");
    $(".pdp-specification_block-title").not(activeTitle).removeClass("active");
    $(".pdp-specification_block-content").not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  })

  // DELIVERY TIMELINE
  const deliveryTime = document.querySelector(".pf-delivery-timeline-wrap");
  if (deliveryTime) {
    function formatDate(date) {
      const options = { month: "short", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    }
    function addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    const today = new Date();
    // Order placed = today
    document.getElementById("pf-dt-order-1").textContent = formatDate(today);
    // Order shipped = +2 to +3 days range
    const shipStart = addDays(today, 1);
    const shipEnd = addDays(today, 4);
    document.getElementById("pf-dt-order-2").textContent =
      `${formatDate(shipStart)}`;
    // Estimated delivery = +1 to +4 days after shipping
    const deliveryStart = addDays(shipStart, 0);
    const deliveryEnd = addDays(shipEnd, 1);
    document.getElementById("pf-dt-order-3").textContent =
      `${formatDate(deliveryStart)}-${formatDate(deliveryEnd)}`;
  }

  $('body').on('click','.pdp-how-to-use-video__play-button', function() {
    console.log('dfdfdfd');
    $(this).addClass('hidden');
    const video = $(this).closest('.pdp-how-to-use_media-wrapper').find('video').get(0);
    video.play();
    video.controls = true;
  })

  // var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  $(document).on('change', '.product-card__variant-select', function() {
    const variantId = $(this).val();
    const $selected = $(this).find(':selected');
    const price = $selected.data('price');
    const comparepirce = $selected.data('comprice');  
    console.log('price', price); 
    console.log('comparepirce', comparepirce); 
    const $form = $(this).closest('form');
    const $input = $form.find('input[name="id"]');
    $input.val(variantId);
    $(this).closest('.product-card').find('.price-list .text-on-sale').text(formatMoney(price, currencyFormat));
    $(this).closest('.product-card').find('.price-list .line-through').text(formatMoney(comparepirce, currencyFormat));
  })

  $('.pf-offers-view-offer').click(function(){
   $(this).parent('.pf-offers-header').next().slideToggle();
  });

  $("body").on("click", ".pf-offers-con-blck-btn", function () {
    var copy_text = $(this);
    var text = $(this).find('.product-offer-code').text();
    var copy_svg = $(this).siblings('.pf-offers-con-blck-code').find('#offer-code-texttt').html();
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html(copy_svg);
    }, 1000);
  })

  $('body').on('click','.product-info__product-claim-text-readmore-more',function(){
    $(this).closest('.product-info__product-claim-text').find('.product-info__product-claim-text_wrapper.default-text').addClass('hidden');
    $(this).closest('.product-info__product-claim-text').find('.product-info__product-claim-text_wrapper.read_more-text').addClass('active');
  })
  $('body').on('click','.product-info__product-claim-text-readmore-less',function(){
    $(this).closest('.product-info__product-claim-text').find('.product-info__product-claim-text_wrapper.default-text').removeClass('hidden');
    $(this).closest('.product-info__product-claim-text').find('.product-info__product-claim-text_wrapper.read_more-text').removeClass('active');
  })

})


